import React from 'react';
import { IBestTime } from "../../api";

export const displayTime = (time: number, highlight = false): string | JSX.Element => {
  const timeInSec = time / 1000;
  if (timeInSec < 60 ) { // poniżej minuty
    const sec = Math.floor(timeInSec);
    const milisec = timeInSec - sec;
    const done1 = '00:' + ('0' + sec.toString()).slice(-2) + '.' + (milisec.toString().replace('0.', '').substring(0, 3) + '000').slice(0, 3);
    if (highlight)
      return highlightTime(done1);
    return done1;
  }
  if (timeInSec < 60 * 60) { // poniżej godziny
    const minutes = Math.floor(timeInSec / 60);
    const seconds = (timeInSec - (minutes*60));
    let secondsString = seconds.toFixed(3).toString()
    if (seconds < 10) {
      secondsString = '0' + secondsString;
    }
    const done2 = ('0' + minutes.toString()).slice(-2) + ':' + secondsString;
    if (highlight)
      return highlightTime(done2);
    return done2;
  }

  const minutes2 = Math.floor(timeInSec / 60);
  const seconds2 = (timeInSec - (minutes2*60));
  const hours = Math.floor(timeInSec / 3600);
  let secondsString2 = seconds2.toFixed(3).toString()
  if (seconds2 < 10) {
    secondsString2 = '0' + secondsString2;
  }
  const done3 = ('0' + hours.toString()).slice(-2) + ':' + ('0' + minutes2.toString()).slice(-2) + ':' + secondsString2;
  if (highlight)
    return highlightTime(done3);
  return done3;
}

const highlightTime = (time: string) => {
  const timeSplit = time.split('');
  const nonZeroIndex = timeSplit.findIndex(x => (x !== ':' && x !== '0'));
  const rest = timeSplit.slice(nonZeroIndex).join('');
  return <div style={{display: 'inline-block', color: '#777'}}><span style={{color: '#000'}}>{rest}</span></div>;
}

export function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}


export function scaleUsersTimes(bests: IBestTime[]): IBestTime[] {
  let lastIndex = 0;

  const bestOutput: IBestTime[] = [];
  const indexArr: {[index: string]: number} = {};

  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < bests.length; i++) {
    if (lastIndex === 10) break;
    if (!Object.keys(indexArr).includes(bests[i].userId.toString())) {
      bestOutput.push(bests[i]);
      indexArr[bests[i].userId] = lastIndex++;
    } else {
      if (!bestOutput[indexArr[bests[i].userId]].additional)
        bestOutput[indexArr[bests[i].userId]].additional = [];
      bestOutput[indexArr[bests[i].userId]].additional?.push(bests[i].time.toString());
    }
  }

  return bestOutput;
}